<template>
  <v-app dark :style="{background: $vuetify.theme.themes['dark'].background}">
    <v-app-bar
      app
      color="rgb(0,124,130,0.5)"
      dark
      elevate-on-scroll
      scroll-target="#scrolling-techniques-5"
      scroll-threshold="500"
      height="150"
    >
          <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(0,124,130,.7), rgba(0, 222, 232,.7)"
        ></v-img>
      </template>
      <div class="d-flex align-center">
        <router-link to="/">
        <v-img
          alt="Crypt-DNA Logo"
          class="shrink mr-2"
          contain
          src="./assets/logo_no_bg_black.svg"
          transition="scale-transition"
          width="300"
        />

        </router-link>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        outlined
        rounded
        color="secondary"
        @click="clickHandler"
      >
        <span class="mr-1 ml-1">CDNA Mint</span>
      </v-btn>
  
    </v-app-bar>

    <v-main class="pt-0">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',



  data: () => ({
    //
  }),
  methods:{
    clickHandler() {
      this.$router.push('/mint')
    }
  }
};
</script>
